import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const PassiveGetExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Passive with "Get"</h2>
      <p>
        In everyday English we often use <strong>get</strong> instead of <strong>be</strong> to form the
        passive voice, especially in informal speech. It focuses on an action that happens to someone or
        something, often unexpectedly or as the result of a specific event.
      </p>

      <div className="example-block">
        <h3><FaLightbulb /> When to use it</h3>
        <ul>
          <li>Accidents and mishaps: <em>He got hurt in the game.</em></li>
          <li>Changes in status: <em>She got promoted last week.</em></li>
          <li>Negative or unfortunate situations: <em>Our flight got delayed by snow.</em></li>
        </ul>
      </div>

      <h3><FaLightbulb /> Forms by tense</h3>
      <div className="grammar-flex-table">
        {[
          ['Tense', 'Form', 'Example'],
          ['Present simple', 'get / gets + past participle', 'Flights often get delayed by snow.'],
          ['Past simple', 'got + past participle', 'We got stuck in Athens for ten hours.'],
          ['Present continuous', 'is / are getting + past participle', 'The situation is getting complicated.'],
          ['Future', 'will get + past participle', 'If it snows, the flight will get cancelled.'],
        ].map(([tense, form, example], index) => (
          <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
            <div className="grammar-cell">{tense}</div>
            <div className="grammar-cell">{form}</div>
            <div className="grammar-cell">{example}</div>
          </div>
        ))}
      </div>

      <div className="example-block">
        <h3><FaLightbulb /> Tip</h3>
        <p>
          "Get" is more common in speech and informal writing. Use "be" for formal or neutral statements.
        </p>
      </div>
    </div>
  );
};

export default PassiveGetExplanation;
